export default "__VITE_ASSET__OFyghhEF__"